<template>
  <div>
    <list
      row-key="DocId "
      ref="list"
      unit="发货单"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
      :show-checkbox="$permission.canDel()"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="发货单号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入发货单号" />
        </el-form-item>
      </template>
      <template slot="table">
        
        <!-- <el-table-column prop="BusiName" label="所属商家" min-width="140px"  v-if="$permission.isStore()==false"/>  -->
        <el-table-column prop="DocNo" label="发货单号" min-width="140px" />
        <el-table-column prop="ExpressNo" label="配送单号" min-width="140px" />
        <el-table-column prop="CompanyName" label="配送公司" min-width="110px" />
        <el-table-column prop="ExpressAmount" label="配送金额" min-width="100px" />
        <el-table-column prop="ContactName" label="收货人" min-width="140px" />
        <el-table-column prop="ContactPhone" label="联系电话" min-width="140px" />
        <el-table-column prop="ContactAddress" label="收货地址" min-width="200px" />
        <el-table-column prop="DocTime" label="发货时间" min-width="140px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocTime)}}</template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/deliver/deliverorder").default,
      params: {
        DocNo: "",
      },
    };
  },
  methods: {

    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },

  },
};
</script>